<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div :class="$style.header">
            <!--<span :class="$style.remove" @click.stop="handleRemoveClick">移除</span>-->
            <!--<span :class="$style.edit" @click.stop="handleEditClick">编辑&nbsp;</span>-->
            <!--<span :class="['iconfont', 'icon-touxiang', $style.avatar]"></span>-->
            <!--<div :class="$style.userInfo">-->
            <!--<span>{{info.last_name}}</span>-->
            <!--<span v-if="info.manager==='T'">-->
            <!--<span v-if="info.users_status" :class="$style.manage">店长</span>-->
            <!--</span>-->
            <!--<span v-if="info.users_status==='INACTIVE'">-->
            <!--<span v-if="info.users_status" :class="$style.frozen">离职</span>-->
            <!--</span>-->
            <!--<p style="font-size: 16px">{{getSex(info.gender)}} <i :class="['iconfont', 'icon-tel03', $style.tel]"></i>{{getPhone(info.mobile)}}-->
            <!--</p>-->
            <!--</div>-->
            <span :class="$style.edit" @click.stop="handleEditClick" v-show="showEdit">编辑</span>

            <div class="channel">


                <div style="text-align: center">

                    <span :class="$style.span_shift" :style="{'background':getBackground(info.icon_color)}">{{info.icon_text}}</span>
                    <div style="overflow:hidden;margin-top: 3px"></div>
                    <span>{{info.start_time}}-{{info.end_time}}</span>
                </div>

                <div style="margin-left: 15px;margin-right:10px;text-align: center">
                    <span style="color:#87909A">工作时长</span>
                    <div style="width:50px;overflow:hidden;margin-top: 3px"></div>
                    <span style="font-weight: bold;font-size: 14px;color: black">{{info.shift_hours}}小时</span>
                </div>

                <div>
                    <span>允许迟到：</span>

                    <span :style="{'color':getTextColor(info.start_time_tolerance)}">{{getFirstCheckIn(0,info.start_time_tolerance)}}</span>

                    <div style="margin-top:5px;overflow:hidden;"></div>
                    <span>允许早退：</span>
                    <span :style="{'color':getTextColor(info.end_time_tolerance)}">{{getFirstCheckIn(0,info.end_time_tolerance)}}</span>

                </div>

            </div>


        </div>
        <!--<div :class="$style.body">-->
        <!--<p v-if="personnelName === 'first'">负责门店数量: <span :class="$style.date">{{info.stores.length}}家</span></p>-->
        <!--<p v-if="personnelName === 'second'">职务: <span :class="$style.date">{{info.title}}</span></p>-->
        <!--</div>-->
        <!-- 模态框 -->
        <el-dialog
                :visible.sync="showModal" :show-close="false"
                width="50%" :class="$style.modal" class="a_modal"
                :before-close="closeModal">
            <div slot="title" :class="$style.title">
                <span>班次详情</span>
                <div>
                    <el-button type="primary" size="small" @click.stop="handleSaveClick">保存</el-button>
                    <el-button type="danger" size="small" @click.stop="closeModal">取消</el-button>
                </div>
            </div>
            <el-form ref="ruleForm" :model="form" label-width="140px" class="info" style="margin-top: -20px">

                <el-form-item label="名称" prop="shift_name">
                    <!--<span>{{form.userName}}</span>-->
                    <el-input v-model="form.shift_name" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="说明" prop="comments">
                    <!--<span>{{form.userName}}</span>-->
                    <el-input type="textarea" placeholder="请输入" v-model="form.comments" maxlength="120"
                              show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="上班时间" prop="start_time">
                    <el-time-picker
                            style="width: 100%"
                            v-model="form.start_time"
                            format='HH:mm'
                            value-format="HH:mm"
                            :picker-options="{
                                selectableRange: '00:00:00 - 23:59:59'
                                }"
                            placeholder="请输入">
                    </el-time-picker>

                </el-form-item>
                <el-form-item label="允许迟到" class="m_modal" prop="start_time_tolerance">
                    <el-input :class="$style.num" v-model="form.start_time_tolerance" type="number" @input="handleChange(1)"></el-input>
                    <span>分钟</span>
                </el-form-item>
                <el-form-item label="下班时间" prop="end_time">
                    <el-time-picker
                            style="width: 100%"
                            v-model="form.end_time"
                            format='HH:mm'
                            value-format="HH:mm"
                            :picker-options="{
                                selectableRange: '00:00:00 - 23:59:59'
                                }"
                            placeholder="请输入">
                    </el-time-picker>

                </el-form-item>
                <el-form-item label="允许早退" class="m_modal" prop="end_time_tolerance">
                    <el-input :class="$style.num" v-model="form.end_time_tolerance" type="number" @input="handleChange(2)"></el-input>
                    <span>分钟</span>
                </el-form-item>
                <el-form-item label="班次简称" prop="icon_text">

                    <el-input v-model="form.icon_text" maxlength="6" show-word-limit></el-input>

                </el-form-item>

                <el-form-item label="图标颜色" prop="icon_color">
                    <el-select v-model="form.icon_color" clearable
                               placeholder="选择颜色" size="small" >
                        <el-option v-for="item in colorArray" :key="item.icon_color"
                                   :label="item.icon_text"
                                   :value="item.icon_color">
                            <span :class="$style.span_color" :style="{'background':getBackground(item.icon_color)}">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span>{{item.icon_text}}</span>
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="启用" prop="status">
                    <el-switch
                            v-model="isON"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>


            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import http from '../../../APIService/http'
    import {bus} from '../../../router/index.js'

    export default {
        props: {
            info: {
                type: Object,
                default: () => {
                }
            },
            personnelName: {
                type: String,
                default: 'first'
            },
            options: {
                type: Array,
                default: () => []
            },
            store_id: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                loading: false,
                showModal: false,
                addShift: false,
                showEidt: false,
                form: {
                    modified_by:''
                },
                storeManager: false,
                isManager: false,
                isON: false,
                deviceLock: false,
                colorArray:[{
                    icon_text:'红色',
                    icon_color:'255,0,0'
                },{
                    icon_text:'绿色',
                    icon_color:'31,132,80'
                },{
                    icon_text:'蓝色',
                    icon_color:'74,144,226'
                },{
                    icon_text:'橙色',
                    icon_color:'255,153,1'
                },{
                    icon_text:'紫色',
                    icon_color:'241,103,240'
                },{
                    icon_text:'蓝灰色',
                    icon_color:'91,95,221'
                },{
                    icon_text:'橙红色',
                    icon_color:'237,59,63'
                },{
                    icon_text:'金黄色',
                    icon_color:'248,231,28'
                },{
                    icon_text:'紫红色',
                    icon_color:'156,26,91'
                },{
                    icon_text:'深橙色',
                    icon_color:'251,127,36'
                }
                ]

            }
        },
        created() {

            let user = this.$store.getters.getUser
            if(!(user.isManage && !user.isSalesDirector) || user.role === 'admin'){
                this.showEdit = true
            }else {
                this.showEdit = false
            }

            bus.$off('action_addShift');
            bus.$on('action_addShift', (value) => {

                this.addShift = true
                this.showModal = true

                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields();
                }


            })

        },
        methods: {
            // 编辑按钮
            handleEditClick() {
                this.form = {...this.info}


                if (this.form.status === 'ACTIVE') {
                    this.isON = true // 是否启用
                } else {
                    this.isON = false
                }


                this.addShift = false
                this.showModal = true
            },
            // 关闭模态框
            closeModal() {
                this.showModal = false
            },
            handleChange(num) {

                if(num === 1){
                    let str= this.form.start_time_tolerance.replace('.','')

                    if(str.length > 6){
                        str = str.substring(0,6)
                    }

                    this.$nextTick(function () {
                        this.form.start_time_tolerance = str
                    })
                }else {
                    let str= this.form.end_time_tolerance.replace('.','')

                    if(str.length > 6){
                        str = str.substring(0,6)
                    }

                    this.$nextTick(function () {
                        this.form.end_time_tolerance = str
                    })
                }



            },
            // 保存按钮
            async handleSaveClick() {

                if (!this.form.shift_name) {
                    this.$message({
                        type: 'error',
                        message: '名称不能为空'
                    })
                    return
                }

                if (!this.form.start_time) {
                    this.$message({
                        type: 'error',
                        message: '请选择上班时间'
                    })
                    return
                }
                if (!this.form.end_time) {
                    this.$message({
                        type: 'error',
                        message: '请选择下班时间'
                    })
                    return
                }

                if (!this.form.icon_text) {
                    this.$message({
                        type: 'error',
                        message: '请输入班次简称'
                    })
                    return
                }

                if (!this.form.icon_color) {
                    this.$message({
                        type: 'error',
                        message: '请选择图标颜色'
                    })
                    return
                }


                if (this.isON) {//在职
                    this.form.status = 'ACTIVE'
                } else {//离职
                    this.form.status = 'INACTIVE'
                }


                this.loading = true

                try {

                    let user = this.$store.getters.getUser

                    if(this.addShift){//新增
                        this.form.tenant_id = user.tenant_id
                        this.form.created_by = user.user_id

                        let storeObj= this.$store.getters.getStore
                        this.form.store_id = storeObj.id

                        this.addShift = false
                    }else {
                        this.form.modified_by = user.user_id
                    }




                    await http.post('/wapi/v1/saveShift', this.form).then(res => {

                        if (res.success) {
                            this.$emit('increment', '')
                            this.$message({
                                type: 'success',
                                message: '修改成功'
                            })
                            this.showModal = false
                            this.loading = false
                        } else {
                            this.showModal = false
                            this.loading = false
                            throw new Error('error')
                        }

                    })


                } catch (err) {
                    this.error('修改失败')
                }

            },

            // 修改班次的背景色
            getBackground(color) {
                return 'rgb(' + color + ')'
            },
            // 修改text颜色
            getTextColor(text) {
                if (!text || text === '0') {
                    return '#D0021B'
                } else {
                    return '#B0B5B9'
                }

            },
            getFirstCheckIn(num, minutes) {
                if (num === 0) {

                    if (!minutes || minutes === '0') {
                        return '不允许'

                    } else {
                        return minutes + '分钟'
                    }

                } else {
                    if (!minutes || minutes === '0') {
                        return '不允许'
                    } else {
                        return minutes + '分钟'
                    }
                }
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        border: 1px solid #979797;
        width: 305px;

        margin-bottom: 20px;
        .num{
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none !important;
                margin: 0;
            }
        }
        .header {
            .edit {
                color: #FF9901;
                font-size: 14px;
                float: right;
                cursor: pointer;
                margin-right: 5px;
            }
            .span_shift {
                font-size: 12px;
                color: #FFFFFF;
                border-radius: 3px;
                padding: 4px;
                display: -moz-inline-box;
                display: inline-block;
                text-align: center;
                line-height: 15px;
                width: 50px;
            }

        }

        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            border-bottom: 2px dotted #e7eaec;
            padding-bottom: 10px;
            > span {
                color: #3998f7;
                font-size: 16px;

            }

        }
    }
    .span_color {
        border-radius: 3px;
    }
</style>

<style scoped>
    .a_modal >>> form {
        width: 90%;
        margin: 0 auto;
    }

    .a_modal >>> .el-form-item__label {
        color: #000000;
        font-size: 16px;
        text-align: right;
        font-weight: bold;
    }

    .a_modal >>> .el-select {
        width: 100%;
    }
    .m_modal >>> .el-input {
        width: 90%;
    }

    .a_modal >>> .el-form-item__content {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
    }

    .channel {
        /*border: solid 1px #87909A;*/
        padding-left: 10px;
        padding-right: 10px;
        margin-top: 10px;
        margin-bottom: 5px;
        font-size: 12px;
        /*border-radius: 4px;*/
        color: #B0B5B9;
        min-height: 58px;
        vertical-align: middle;

        /*display: flex;*/
        /*justify-content: space-around;*/
        display: flex;
        align-items: center;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/pages/stores/attendance/item.vue